import React, { useState } from "react";
import { Bbox } from "../rootState";
import { DelimitedSection } from "../core/core-widgets/surfaces/DelimitedSection/DelimitedSection";
import { BasicButton, ButtonColor } from "../core/core-widgets";
import { BasicSelect } from "../core/core-widgets/inputs/BasicSelect";
import { SpacingBox } from "../core/core-widgets/boxes/SpacingBox/SpacingBox";

export interface ExportMapProps {
    enabled: boolean;
    outputFormats: string[];
    bbox?: Bbox;
    gisServerUrl: string;
    layers: string;
    getFile: (selectedFormat: string, layers: string, bbox: Bbox, gisServerUrl: string) => void;
}

export interface ExportMapDispatchProps {}

export const ExportMap = (props: ExportMapProps & ExportMapDispatchProps) => {
    const { enabled, outputFormats, bbox, gisServerUrl, layers, getFile } = props;
    const [selectedFormat, setSelectedFormat] = useState("select");
    if (!enabled) {
        return null;
    }

    return (
        <>
            <DelimitedSection title={"Export Map to all available formats"}>
                <div id={"exportMap"} className={"exportMap"}>
                    <BasicSelect
                        className={"select-formats"}
                        options={outputFormats.map((value) => ({ value: value, label: value }))}
                        onChangeValue={(value) => setSelectedFormat(value)}
                    />
                    <SpacingBox my={2}>
                        <BasicButton
                            id={"saveFile"}
                            color={ButtonColor.PRIMARY}
                            onClick={() => getFile(selectedFormat, layers, bbox!, gisServerUrl)}
                        >
                            Save
                        </BasicButton>
                    </SpacingBox>
                </div>
            </DelimitedSection>
        </>
    );
};
